import { render, staticRenderFns } from "./VideoSharing.vue?vue&type=template&id=4a6232fd&scoped=true&"
import script from "./VideoSharing.vue?vue&type=script&lang=ts&"
export * from "./VideoSharing.vue?vue&type=script&lang=ts&"
import style0 from "./VideoSharing.vue?vue&type=style&index=0&id=4a6232fd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a6232fd",
  null
  
)

export default component.exports